import { createAction } from '@reduxjs/toolkit';
import { PConfirmCreate, PInfoByHash } from './types';

export const fetchPersonalInfo = createAction('user/fetchPersonalInfo');

export const fetchUserInfo = createAction<PInfoByHash>('user/fetchUserInfo');

export const fetchConfirmCreate =
  createAction<PConfirmCreate>('user/confirmCreate');
